import axios from "axios";
import React, { useState, useEffect } from "react";
import profile from "../../assets/images/profile.jpg";
import { APIURL } from "../../redux/action/config";
import dateFormat from "dateformat";
import { Formik } from "formik";
import { addVehicle } from "../../redux/action/customers";
import { useDispatch } from "react-redux";
import * as Yup from "yup";

export const vehicleItems = ['Car', 'Bicycle', 'Motorcycle/ATV', 'Golf Cart']

const AddVehicle = (props) => {
  const dispatch = useDispatch();
  const userID = props.userID;
  const VehicleSchema = Yup.object().shape({
    year: Yup.string().required("Year  is required"),
    name: Yup.string().required("Name  is required"),
    model: Yup.string().required("Model is required"),
    color: Yup.string().required("Color is required"),
    reg_no: Yup.string().required("License no is required"),
  });

  return (
    <React.Fragment>
      <div
        className="modal fade"
        id={props.modalId}
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header border-0 d-flex">
              <div className="text-center">
                <h1 className=" text-primary">Add Vehicle</h1>
                {/* <div className="text-muted fw-bold fs-5">
                      If you need more info, please check out.
                    </div> */}
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="modal-body p-0">
                <Formik
                  initialValues={{
                    year: "",
                    name: "",
                    model: "",
                    color: "",
                    reg_no: "",
                  }}
                  validationSchema={VehicleSchema}
                  onSubmit={(values) => {
                    dispatch(addVehicle(values, userID));
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                  }) => (
                    <form className="form">
                      <div className="row mb-8">
                        <div className="col-xl-3">
                          <div className="fs-6 fw-bold mt-2 mb-3">Select Vehicle</div>
                        </div>
                        <div className="col-xl-9 fv-row fv-plugins-icon-container">
                          <select
                            className="form-select form-control form-control-solid"
                            aria-label="Select example"
                            onChange={handleChange}
                            name="type"
                            id="type"
                            defaultValue={values?.name}
                          >
                            <option>Select Vehicle</option>
                            {vehicleItems.map((item) =>
                              <option value={item}>{item}</option>
                            )}

                          </select>
                          {errors.type ? (
                            <div
                              className="text-danger mt-2"
                              style={{ fontSize: "14px" }}
                            >
                              {errors.type}
                            </div>
                          ) : null}
                          <div className="fv-plugins-message-container invalid-feedback"></div>
                        </div>
                      </div>
                      <div className="row mb-8">
                        <div className="col-xl-3">
                          <div className="fs-6 fw-bold mt-2 mb-3"><span className="required">Year</span></div>
                        </div>
                        <div className="col-xl-9 fv-row fv-plugins-icon-container">
                          <input
                            type="number"
                            className="form-control form-control-solid"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="year"
                            id="year"
                            defaultValue={values?.year}
                          />
                          {errors.year && touched.year ? (
                            <div
                              className="text-danger mt-2"
                              style={{ fontSize: "14px" }}
                            >
                              {errors.year}
                            </div>
                          ) : null}
                          <div className="fv-plugins-message-container invalid-feedback"></div>
                        </div>
                      </div>
                      <div className="row mb-8">
                        <div className="col-xl-3">
                          <div className="fs-6 fw-bold mt-2 mb-3"><span className="required">Vehicle Make</span></div>
                        </div>
                        <div className="col-xl-9 fv-row fv-plugins-icon-container">
                          <input
                            type="text"
                            className="form-control form-control-solid"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="name"
                            id="name"
                            defaultValue={values?.name}
                          />
                          {errors.name && touched.name ? (
                            <div
                              className="text-danger mt-2"
                              style={{ fontSize: "14px" }}
                            >
                              {errors.name}
                            </div>
                          ) : null}
                          <div className="fv-plugins-message-container invalid-feedback"></div>
                        </div>
                      </div>
                      <div className="row mb-8">
                        <div className="col-xl-3">
                          <div className="fs-6 fw-bold mt-2 mb-3"><span className="required">Vehicle Model</span></div>
                        </div>
                        <div className="membership-form-check col-xl-9 fv-row fv-plugins-icon-container d-flex flex-wrap checkbox">
                          <input
                            type="text"
                            className="form-control form-control-solid"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="model"
                            id="model"
                            defaultValue={values.model}
                          />
                          {errors.model && touched.model ? (
                            <div
                              className="text-danger mt-2"
                              style={{ fontSize: "14px" }}
                            >
                              {errors.model}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="row mb-8">
                        <div className="col-xl-3">
                          <div className="fs-6 fw-bold mt-2 mb-3"><span className="required">Color</span></div>
                        </div>
                        <div className="col-xl-9 fv-row fv-plugins-icon-container">
                          <input
                            type="text"
                            className="form-control form-control-solid"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="color"
                            id="color"
                            defaultValue={values?.color}
                          />
                          {errors.color && touched.color ? (
                            <div
                              className="text-danger mt-2"
                              style={{ fontSize: "14px" }}
                            >
                              {errors.color}
                            </div>
                          ) : null}
                          <div className="fv-plugins-message-container invalid-feedback"></div>
                        </div>
                      </div>
                      <div className="row mb-8">
                        <div className="col-xl-3">
                          <div className="fs-6 fw-bold mt-2 mb-3">
                            <span className="required">License Number</span>
                          </div>
                        </div>
                        <div className="col-xl-9 fv-row fv-plugins-icon-container">
                          {/* <textarea
                            rows="3"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="reg_no"
                            id="reg_no"
                            className="form-control form-control-solid"
                            defaultValue={values?.reg_no}
                          ></textarea> */}
                          <input
                            type="text"
                            className="form-control form-control-solid"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="reg_no"
                            id="reg_no"
                            defaultValue={values?.reg_no}
                          />
                          {errors.reg_no && touched.reg_no ? (
                            <div
                              className="text-danger mt-2"
                              style={{ fontSize: "14px" }}
                            >
                              {errors.reg_no}
                            </div>
                          ) : null}
                          <div className="fv-plugins-message-container invalid-feedback"></div>
                        </div>
                      </div>
                      <div className="separator mb-6"></div>
                      <div className="d-flex justify-content-end">
                        <button
                          onClick={handleSubmit}
                          type="submit"
                          className="btn btn-primary"
                        >
                          <span className="indicator-label">Save</span>
                        </button>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default AddVehicle;
